import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AutoComplete from '@mui/material/Autocomplete';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const PackEntry = (props) => {
  const {pat_id} = useParams();
  const [packcats,setpackcats] = useState([]);
  const [insur,setInsur] = useState([]);
  const [patientData, setPatientData] = useState([]);
  const [consData, setConsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([{ id: '', packsubcat: '', amount: '' }]);
    const inputRefs = useRef([]);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const [disPer, setDisPer] = useState(0);
  const [disAmount, setDisAmount] = useState(0);
  const [packData,setpackData]=useState({
        "pat":'',
        "cons":'',
        "pack_id":'',
        "pack_test":'',
        "pack_amount":'',
        "pack_tot":'',
        "pack_disc":'',
        "pack_status":'',
        "addedby":'',
        "ip_add":'',
    });
useEffect(() => {
    const fetchData = async () => {
      try {
        const [patResponse, packResponse, consResponse] = await Promise.all([
          axios.get(`${baseUrl}edit-patient/${pat_id}`),
          axios.get(`${baseUrl}create-pack-price/`),
          axios.get(`${baseUrl}cons-search/`),
        ]);
        if (patResponse.status === 200 || patResponse.status === 201) {
          setPatientData(patResponse.data);
        } else {
          window.location.href = '/pat-search/';
        }
        setItems(packResponse.data);
        setConsData(consResponse.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);



  const handleKeyDown = (e, index) => {
    const newRows = [...rows];
    switch (e.keyCode) {
      // Handle Shift key
        case 38:
          e.preventDefault();
          if (newRows[index].selectedItem === 0) {
            newRows[index].selectedItem = items.length - 1;
          } else {
            newRows[index].selectedItem--;
          }
          setRows(newRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newRows[index].selectedItem === items.length - 1) {
            newRows[index].selectedItem = 0;
          } else {
            newRows[index].selectedItem++;
          }
          setRows(newRows);
          break;
      default:
        break;
    }
  };

const handleSelect = (value, index, id) => {
  if (value === undefined || value === null) {
    const newRows = [...rows];
    newRows[index] = { id: '', packsubcat: '', amount: '' };
    setRows(newRows);
  } else {
    const selectedItem = value;
    if (selectedItem) {
      const newRows = [...rows];
      newRows[index] = {
        id: selectedItem.id,
        packsubcat: selectedItem.pack.packsubcat,
        amount: selectedItem.amount
      };
      setRows(newRows);
    }
  }
};

  const handleAmountChange = (e, index) => {
    const newRows = [...rows];
    newRows[index].amount = parseFloat(e.target.value) || 0;
    setRows(newRows);
  };

useEffect(() => {
      inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [rows]);


  const handleDisPerChange = (e) => {
    const newDisPer = parseFloat(e.target.value) || 0;
    setDisPer(newDisPer);
  };

  useEffect(() => {
    let subTotal = 0;
    let disAmount = 0;

    let newTotal = 0;
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      subTotal += row.amount;
      disAmount = subTotal * ( parseFloat(disPer) /100 );
      newTotal = subTotal - disAmount;
    }
    setSubTotal(subTotal);
    setDisPer(disPer);
    setDisAmount(disAmount);
    setTotal(newTotal);
  }, [rows, disPer]);

  const consultantOptions = consData.map((cons) => ({
    value: cons.id,
    label: cons.consultant,
  }));

  const handleChange = (index, key, value) => {
    const updatedRows = [...rows];
    updatedRows[index][key] = value;
    setRows(updatedRows);
  };

  const handleConsChange = (event, value) => {
    if (value) {
      setpackData(prevState => ({ ...prevState, cons: value.value }));
    } else {
      setpackData(prevState => ({ ...prevState, cons: '' }));
    }
  };

  const formSubmit = (e) => {
    e.preventDefault();
        const _formData = new FormData();
        if (!packData.cons) {
            Swal.fire('Error', 'Please select a consultant.', 'error');
            return;
          }
        _formData.append('pat', pat_id);
        _formData.append('cons', packData.cons.value);
        _formData.append('pack_price', rows.map(row => row.id).join(','));
        _formData.append('pack_test', rows.map(row => row.packsubcat).join(','));
        _formData.append('pack_amount', rows.map(row => row.amount).join(','));
        _formData.append('pack_tot', total);
        _formData.append('pack_disc', disAmount.toString());
        _formData.append('pack_status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);

        axios.post(`${baseUrl}create-pack-entry/`, _formData)
          .then(response => {
            if(response.status==200 || response.status==201){
              Swal.fire({
                title: 'pack entry has been added.',
                icon: 'success',
                timer: 5000,
                showConfirmButton: false
              });
              setpackData({
                pat: '',
                cons: '',
                pack_id: '',
                pack_test: '',
                pack_amount: '',
                pack_tot: '',
                pack_disc: '',
                pack_status: '',
                addedby: '',
                ip_add: '',
              });
              setRows([{ id: '', packsubcat: '', amount: '' }]);
              setTotal(0);
              setSubTotal(0);
              setDisPer(0);
              setDisAmount('');
              setTimeout(() => {
                window.location.href = '/pack-request';
              }, 3000);
            }
          })
          .catch(error => {
            console.log(error);
            Swal.fire(
              'Error!',
              'Failed to add pack entry. Please try again later.',
              'error'
            );
          });

  };

  return (
    <section className="container mt-4">
      <form>
        <div className="row table-responsive">
          <div className='col-md-12 col-12 mb-2'>
          <table className="erp-table-modern">
              <thead>
                <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                  <th>Patient ID</th>
                  <th>Patient Name</th>
                  <th>Gender</th>
                  <th>D.O.B/Age</th>
                  <th>Marital Status</th>
                  <th>Regd. On</th>
                  <th>Consultant</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{patientData.pat_id}</td>
                  <td>{patientData.patient}</td>
                  <td>{patientData.gender}</td>
                  <td>{patientData.age}</td>
                  <td>{patientData.marital_status}</td>
                  <td>{patientData.add_date}</td>

                    <td>
                      {consData.length > 0 && (
                        <AutoComplete
                          id="combo-box-demo"
                          options={consultantOptions}
                          onChange={(event, value) => setpackData(prevState => ({ ...prevState, cons: value }))}
                          renderInput={(params) => (
                            <TextField {...params} onChange={handleConsChange} name="cons" />
                          )}
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                        />
                      )}
                    </td>

                  </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div className="table-responsive">
          <table className="erp-table-modern">
            <thead>
              <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                <th>ID</th>
                <th>Name</th>
                <th>Total</th>

              </tr>
            </thead>
          <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
            <td>
                <input
                  type="text"
                  className="form-control"
                  style={{width: 80}}
                  name="id"
                  value={row.id}
                  onChange={(e) => handleChange(e, index, 'id')}
                  readOnly
                />
              </td>
              <td>
                <AutoComplete
                  className="form-control mt-2"
                    items={items}
                    options={items}
                  onChange={(event, value, id) => handleSelect(value, index, id)}
                  onInputChange={(event, newInputValue) => {
                    // Update input value
                    setRows(prevRows => {
                      const updatedRows = [...prevRows];
                      updatedRows[index].packsubcat = newInputValue;
                      return updatedRows;
                            });
                  }}
                 onKeyDown={e => handleKeyDown(e, index)}
                getOptionLabel={(option) => option.pack ? option.pack.packsubcat : ''}

                   renderOption={(props, option) => (
                      <Box component="li" {...props}
                      fullWidth
                      sx={{
                      width: 750,
                      height: 50,
                      borderRadius: 1,
                        }}
                      >
                        {option.pack ? `${option.pack.packsubcat} Insurance: ${option.insur.company}  ` : ''}
                      </Box>

                    )}
                 renderInput={(params) => (
                  <div ref={params.InputProps.ref}
                  >
                    <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                           fullWidth
                           style={{
                              width: 500,
                              background: "#F7EEFF",
                              }}
                     />
                  </div>
                )}
                 ref={(el) => inputRefs.current[index] = el}
                />
              </td>
              <td>
                <input

                  type="number"
                  className="form-control"
                  style={{width: 100}}
                  value={row.amount}
                  name="amount"
                  onChange={handleChange}
                  onChange={(e) => handleAmountChange(e, index)}
                  readOnly
                />
              </td>

            </tr>
          ))}
                   </tbody>
      </table>

          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}} className='ms-5' >
            <div className="form-group">
              <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
              <div className="input-group">
                <div className="input-group-addon me-2 ">&#8377;</div>
                <input type="number" value={subtotal} readOnly/>
              </div>
            </div>
            <div className="form-group mt-3" >
              <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
              <div className="input-group">
                <div className="input-group-addon me-2 ">%</div>
                <input type="number" value={disPer} name="disPer" id="disPer" onChange={handleDisPerChange} />
              </div>
            </div>
            <div className="form-group mt-3" >
              <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
              <div className="input-group">
                <div className="input-group-addon me-2 ">&#8377;</div>
                <input type="number" value={disAmount} readOnly/>
              </div>
            </div>
            <div className="form-group mt-3">
              <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
              <div className="input-group">
                <div className="input-group-addon me-2 ">&#8377;</div>
                <input type="number" value={total} readOnly/>
              </div>
            </div>
            <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
          </div>
        </div>
      </form>
    </section>
  );
};

export default PackEntry;
